/** Placeholder bars with a slow shimmer (the "Motion" CSS); decorative, so hidden from screen readers. */
export default function Skeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div className="skeleton" aria-hidden="true">
      {Array.from({ length: lines }, (_, i) => (
        <span key={i} className="skeleton-line" style={{ width: `${Math.max(30, 88 - i * 18)}%` }} />
      ))}
    </div>
  );
}
